import type { ControleMontagem } from './useMontagemEstabilizacao'
import './PainelMontagemEstabilizacao.css'

export function PainelMontagemEstabilizacao({ montagem: m, aoEscolherNaCena }: { montagem: ControleMontagem; aoEscolherNaCena?: () => void }) {
  if (!m.visivel) return <p>Escolha fita catraca na barra de equipamentos. Para editar uma ligação, selecione-a na cena.</p>
  return <section className="montagem-estabilizacao" aria-label="Montagem de fita catraca">
    <p role="status"><strong>{m.instrucao}</strong></p>
    {m.campo && aoEscolherNaCena && <button onClick={aoEscolherNaCena}>Escolher na cena</button>}
    {m.campo && <label>Ponto de {({ contato: 'contato', ancora: 'ancoragem', origem: 'origem', destino: 'destino' })[m.campo]}
      <select aria-label={`Ponto de ${{ contato: 'contato', ancora: 'ancoragem', origem: 'origem', destino: 'destino' }[m.campo]}`} value="" onChange={e => m.escolher(e.target.value)}>
        <option value="">Escolher na cena ou nesta lista…</option>
        {m.disponiveis.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
      </select>
    </label>}
    {(['origem', 'destino'] as const).filter(c => m.ligacao[c]).map(c => <div className="montagem-estabilizacao__ponto" key={c}>
      <span>{m.pontos.find(p => p.id === m.ligacao[c])?.nome ?? 'Ponto indisponível'}</span>
      <button onClick={() => m.editar(c)} aria-label={`Trocar ${c}`}>Trocar</button>
    </div>)}
    {m.tipo === 'fitaCatraca' && <label className="montagem-estabilizacao__checkbox"><input type="checkbox" checked={m.ligacao.retorno ?? true} onChange={e => m.alterarRetorno(e.target.checked)} />Passar no segundo ponto e voltar ao primeiro</label>}
    <p>{m.ligacao.tensionada ? 'Fita tensionada no exercício.' : m.validacao.mensagem}</p>
    <div className="montagem-estabilizacao__acoes">
      <button disabled={!m.validacao.completa && !m.ligacao.tensionada} onClick={m.tensionar}>{m.ligacao.tensionada ? 'Soltar fita' : 'Tensionar fita'}</button>
      <button onClick={m.cancelar}>{m.item ? 'Nova montagem' : 'Cancelar escolha'}</button>
    </div>
    <small>Geometria didática: não calcula resistência dos pontos nem capacidade de carga do conjunto.</small>
  </section>
}
